module.exports = __webpack_public_path__ + "static/img/add.6ecb8125.svg";